import React, { useEffect, useState } from "react";
import DashPanel from "../../molecules/DashPanel";
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  Order,
  OrderSearchOption,
  SearchResult,
  getKrOrderStatus,
  CommonUtil as cu,
  OrderWaitingSearchOption,
  OrderWaiting,
} from "../../../types/elements";
import { gqladm } from "../../../graphql/gqladm";
import ItemCard from "../../molecules/ItemCard";

export interface PanelOrderWaitingsProps {}
export const PanelOrderWaitings: React.FC<PanelOrderWaitingsProps> = (props) => {
  const [sopt, setSopt] = useState<OrderWaitingSearchOption>({
    limit: 10,
    offset: 0,
    ow_status: 'WAITING'
  });
  const [result, setResult] = useState<SearchResult<OrderWaiting>>({});

  const load = (opt: OrderWaitingSearchOption) => {
    gqladm
      .getOrderWaitings({ ...sopt, ...opt })
      .then((result) => {
        setResult(result);
        setSopt({ ...sopt, offset: result.offset ? result.offset : sopt.offset });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangePage = (page: number) => {
    console.log("handleChangePage", page);
    const offset = (page - 1) * (sopt.limit ? sopt.limit : 10);
    if (offset !== sopt.offset) {
      load({ ...sopt, offset: offset });
    }
  };

  useEffect(() => {
    load(sopt);
  }, []);

  return (
    <DashPanel title="최근 주문대기" actions={<div></div>}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Items</TableCell>
            <TableCell>금액</TableCell>
            <TableCell>생성</TableCell>
            <TableCell>상태</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {result.list?.map((o, idx) => {
            return (
              <TableRow key={idx}>
                <TableCell>{o.id}</TableCell>
                <TableCell>
                  <div style={{ display: "flex" }}>
                    {o.orderWaitingItems?.map(
                      (oi, oiidx) => oi.item && <ItemCard key={oiidx} type="mini" item={oi.item} />
                    )}
                  </div>
                </TableCell>
                
                <TableCell>{o.price}</TableCell>
                <TableCell>{o.created && cu.getFormattedDate(o.created, "MM/dd HH:mm")}</TableCell>
                <TableCell>{o.ow_status}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell colSpan={6}>
              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <Pagination
                  onChange={(e, p) => handleChangePage(p)}
                  count={Math.ceil(
                    (result.total ? result.total : 0) / (result?.limit ? result.limit : 10)
                  )}
                  page={
                    Math.ceil(
                      (result?.offset ? result.offset : 0) / (result?.limit ? result.limit : 10)
                    ) + 1
                  }
                />
              </div>
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </DashPanel>
  );
};
